<template>
  <div id="map-container" class="map">
    <div id="map" ref="mapRef" style="height: 100%" />
  </div>
</template>

<script>
import Radar from 'radar-sdk-js'
import { markRaw } from 'vue'
import 'radar-sdk-js/dist/radar.css'
import { mapState } from 'vuex'

import InfoWindowView from './InfoWindowView.vue'
import { createApp } from 'vue'
export default {
  data() {
    return {
      center: this.mapCenter ? this.mapCenter : { lat: 38.01663433250827, lng: -98.16988275885976 },
      zoom: this.mapZoom ? this.mapZoom : 5,
      options: {
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: null,
      },
      markers: [],
      map: null,
      mapRef: null,
      icon: {
        url: '',
      },
      userIcon: {
        url: '',
      },
    }
  },
  props: ['selectedService', 'mapCenter', 'mapZoom', 'mapMarkers', 'fitBounds'],
  watch: {
    branding(newVal, oldVal) {
      if (oldVal == null && newVal) {
        this.options.styles = this.branding.map_style
        this.icon.url = this.branding.markers.store_marker
        this.userIcon.url = this.branding.markers.user_marker
      }
    },
  },
  computed: {
    ...mapState(['branding']),
  },
  methods: {
    initRadarMap() {
      Radar.initialize('prj_live_pk_3b40e3b1526b84d6a1d203736df2da66a0a8d082')

      this.map = markRaw(
        Radar.ui.map({
          container: this.mapRef,
          style: this.branding.radar_map_style || 'radar-default-v1',
          center: this.center,
          zoom: this.zoom,
          ...this.options,
        })
      )
    },

    removeMarkers() {
      this.map.clearMarkers()
    },

    createMarkers(stores, selectedAddressLat, selectedAddressLng) {
      try {
        this.removeMarkers()

        if (selectedAddressLat && selectedAddressLng && !isNaN(selectedAddressLat) && !isNaN(selectedAddressLng)) {
          this.addUserMarker(selectedAddressLat, selectedAddressLng)
        }

        if (this.mapMarkers) {
          this.mapMarkers.forEach((marker) => {
            if (
              !marker.position.lat ||
              !marker.position.lng ||
              isNaN(marker.position.lat) ||
              isNaN(marker.position.lng)
            ) {
              return
            }
            const confirmationMarker = Radar.ui
              .marker({
                url: marker.icon.url,
                width: '37px',
                height: '50px',
              })
              .setLngLat([parseFloat(marker.position.lng), parseFloat(marker.position.lat)])
              .addTo(this.map)
            marker.hasInfoWindow = false
            this.map.markers = this.map.markers || []
            this.map.markers.push(confirmationMarker)
          })
        }

        if (stores) {
          stores.forEach((store) => {
            if (!store.longitude || !store.latitude || isNaN(store.longitude) || isNaN(store.latitude)) {
              return
            }
            const marker = Radar.ui
              .marker({
                url: store.extra?.icon || this.icon.url,
                width: '37px',
                height: '50px',
              })
              .setLngLat([parseFloat(store.longitude), parseFloat(store.latitude)])
              .addTo(this.map)
              .on('click', () => {
                this.openInfoWindow(marker, store?.store_id)
              })

            marker.store = store
            marker.hasInfoWindow = true
            this.map.markers = this.map.markers || []
            this.map.markers.push(marker)
          })
        }

        if (this.map.markers && this.map.markers.length > 0) {
          this.adjustMapZoom()
        }
      } catch (error) {
        console.log(error)
      }
    },
    createMapInfoWindow() {
      this.map.markers.forEach((marker) => {
        if (marker.hasInfoWindow) {
          marker.on('click', () => {
            this.openInfoWindow(marker)
          })
        }
      })
    },
    openInfoWindow(marker, storeId) {
      if (storeId) {
        marker = this.map.markers.find((marker) => {
          return marker?.store?.store_id === storeId
        })
      }
      this.$emit('clickedStoreId', marker?.store?.store_id)
      this.map.setCenter(marker.getLngLat())
      this.map.setZoom(10)
      this.map.markers.forEach((marker) => {
        if (marker.infoWindow) {
          marker.infoWindow.remove()
        }
      })
      const app = createApp(InfoWindowView, {
        store: marker.store,
        selectedService: this.selectedService,
        darkMode: this.branding?.dark_mode_enabled,
        showAddress: this.branding.display_options?.hide_store_address,
        showPhone: this.branding.display_options?.hide_restaurant_phone_number,
        onSelectStore: (store, from) => {
          this.$emit('selectStore', store, from)
        },
      })
      const componentInstance = app.mount(document.createElement('div'))
      marker.infoWindow = Radar.ui
        .popup({
          offset: 35,
          content: document.createElement('div'),
        })
        .setLngLat(marker.getLngLat())
        .setDOMContent(componentInstance.$el)
        .addTo(this.map)
    },
    addUserMarker(selectedAddressLat, selectedAddressLng) {
      const userMarker = Radar.ui
        .marker({
          url: this.userIcon.url,
          width: '37px',
          height: '50px',
        })
        .setLngLat([selectedAddressLng, selectedAddressLat])
        .addTo(this.map)

      this.map.markers = this.map.markers || []
      this.map.markers.push(userMarker)

      if (this.fitBounds) {
        this.adjustMapZoom()
      }
    },
    adjustMapZoom() {
      if (this.map.markers && this.map.markers.length > 0) {
        this.map.fitToMarkers({ maxZoom: 14, padding: 80 })
      }
    },
  },
  created() {
    this.options.styles = this.branding.map_style
    this.icon.url = this.branding.markers.store_marker
    this.userIcon.url = this.branding.markers.user_marker
  },
  mounted() {
    this.mapRef = this.$refs.mapRef
    setTimeout(() => {
      this.initRadarMap()
    }, 500)
  },
}
</script>

<style>
.custom-marker {
  background-repeat: no-repeat;
  background-position: center;
}

.maplibregl-popup-content {
  width: 300px;
}
.maplibregl-popup-close-button {
  color: #292828;
}
.maplibregl-popup-close-button:hover {
  background-color: transparent;
}

.custom-marker {
  background-repeat: no-repeat;
  background-position: center;
}

.mapInfo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.storeInfo {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.line {
  display: flex;
  align-items: center;
  column-gap: 10px;
  flex-wrap: wrap;
}

.line img {
  height: 16px;
}

.line p {
  color: var(--passive-color);
}

.action {
  text-decoration-color: #292828;
}

.action p {
  font-family: var(--regular-font) !important;
}
</style>
